import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '@/pages/HomePage';
import ResumePage from '@/pages/ResumePage';

Vue.use(Router);

const router = new Router({
	mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
	routes: [
		{
			path: '/',
			name: 'HomePage',
			component: HomePage,
			alias: ['/about', '/projects', '/contact'],
			meta: {
				title: 'About'
			}
		},
		{
			path: '/resume',
			name: 'ResumePage',
			component: ResumePage,
			meta: {
				title: 'Resume'
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title + ' | Matthew Steven';
	next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js